export const navigationLinks = {
	primary: [
		{
			title: 'Трансляции',
			url: '/live'
		},
		{
			title: 'Нацпроект',
			url: '/national-streaming'
		},
		{
			title: 'Фильмы',
			url: '/cinema/movies'
		},
		{
			title: 'Спектакли',
			url: '/theaters/performances'
		},
		{
			title: 'Концерты',
			url: '/music/concerts'
		},
		{
			title: 'Образование',
			url: '/lectures/movies'
		}
	],
	secondary: [
		{
			title: 'Кино',
			url: '/cinema'
		},
		{
			title: 'Музеи',
			url: '/museums'
		},
		{
			title: 'Музыка',
			url: '/music'
		},
		{
			title: 'Театры',
			url: '/theaters'
		},
		{
			title: 'Архитектура',
			url: '/architecture'
		},
		{
			title: 'Традиции',
			url: '/traditions'
		},
		{
			title: 'Афиша',
			url: '/afisha'
		},
		{
			title: 'Образы России',
			url: '/russia'
		}
	]
};
